import { render, staticRenderFns } from "./userPhoneButtons.vue?vue&type=template&id=c1512c0e&scoped=true"
import script from "./userPhoneButtons.vue?vue&type=script&lang=js"
export * from "./userPhoneButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1512c0e",
  null
  
)

export default component.exports